import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  text-align: left;

  label {
    padding-top: 8px;
  }
`
